<template>
    <transition name="fade">
        <div v-if="show" :class="alertClass" >
            {{$t(message)}}
            <div class="text-right">
                <a class="button--link inline-block--small" @click.prevent="$emit('confirm')">{{$t(confirmText)}}</a>
                <a class="button--link inline-block--small" @click.prevent="$emit('reject')">{{$t(rejectText)}}</a>
            </div>
        </div>
    </transition>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    @Component
    export default class ConfirmationAlert extends Vue {
        name = 'confirmation-alert';

        @Prop() show;
        @Prop() message;

        @Prop({ default: 'alert--error'}) alertClass;
        @Prop({ default: 'common.yes' }) confirmText;
        @Prop({ default: 'common.no' }) rejectText;

    }

</script>



// WEBPACK FOOTER //
// src/components/general/ConfirmationAlert.vue